/**
 * @auth 赖传峰
 * @date 2024/8/30
 * @desc 移除路径结尾的斜线
 */
const TRAILING_SLASH_RE = /\/$/
export default (path: string) => path.replace(TRAILING_SLASH_RE, '');
